import stateGenerator from './state-generator'
import * as actions from './actions'
import * as extraReducers from './extra-reducers'

const queryFeature = {
  generator: {
    ...stateGenerator
  },
  actions,
  extraReducers
}

export default queryFeature
export * from './query-processor'
